export default __webpack_public_path__ + "8ad9abc799101b34bded1b7d2b9fc805.jpg";